import Active from './Active'

export const Profile = {
  Active
}
